/**
 * Cura — Testimonials Slider
 * Desktop/tablet: JS transform-based, 3 cards (desktop) / 2 cards (tablet).
 * Mobile: native CSS scroll with snap — JS disabled.
 */
(function () {
  'use strict';

  var GAP_PX = 20;

  function isMobile() { return window.innerWidth <= 749; }
  function isTablet()  { return window.innerWidth >= 750 && window.innerWidth <= 989; }

  class CuraTestimonials {
    constructor(section) {
      this.section  = section;
      this.track    = section.querySelector('[data-test-track]');
      this.cards    = Array.from(section.querySelectorAll('[data-test-card]'));
      this.prevBtn  = section.querySelector('[data-test-prev]');
      this.nextBtn  = section.querySelector('[data-test-next]');
      this.current  = 0;
      this.total    = this.cards.length;

      if (!this.track || this.total === 0) return;

      this.bindEvents();
      this.update();
      window.addEventListener('resize', () => this.update());
    }

    visibleCount() {
      if (isMobile())  return null;
      if (isTablet())  return 2;
      return 3;
    }

    maxIndex() {
      var vis = this.visibleCount();
      if (!vis) return 0;
      return Math.max(0, this.total - vis);
    }

    goTo(index) {
      if (isMobile()) return;
      this.current = Math.max(0, Math.min(index, this.maxIndex()));
      this.applyTransform();
      this.updateButtons();
    }

    applyTransform() {
      if (isMobile() || !this.cards.length) return;
      var cardWidth = this.cards[0].offsetWidth;
      var offset = this.current * (cardWidth + GAP_PX);
      this.track.style.transform = 'translateX(-' + offset + 'px)';
    }

    update() {
      if (isMobile()) {
        this.track.style.transform = '';
        this.current = 0;
        if (this.prevBtn) this.prevBtn.style.display = 'none';
        if (this.nextBtn) this.nextBtn.style.display = 'none';
        return;
      }
      if (this.prevBtn) this.prevBtn.style.display = '';
      if (this.nextBtn) this.nextBtn.style.display = '';
      this.current = Math.min(this.current, this.maxIndex());
      this.applyTransform();
      this.updateButtons();
    }

    updateButtons() {
      if (this.prevBtn) this.prevBtn.disabled = this.current === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.current >= this.maxIndex();
    }

    bindEvents() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.goTo(this.current - 1));
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.goTo(this.current + 1));
      }
      this.section.addEventListener('keydown', (e) => {
        if (isMobile()) return;
        if (e.key === 'ArrowLeft')  this.goTo(this.current - 1);
        if (e.key === 'ArrowRight') this.goTo(this.current + 1);
      });
    }
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('[data-test-slider]').forEach(function (el) {
      var section = el.closest('section') || el;
      if (!section.dataset.testInit) {
        new CuraTestimonials(section);
        section.dataset.testInit = 'true';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();